var render = function render(){var _vm=this,_c=_vm._self._c;return _c('examples-block',{attrs:{"gitUrl":"src/components/examples/Modal/modalView/SettingModalContent.vue","title":"Несколько модальных окон c настройками отключение закрытия и состоянием возврата назад"}},[_c('r-button',{attrs:{"title":"Отрыть модальное окно"},on:{"click":_vm.openModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }